"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _AaHoverState = require("./AaHoverState");

var _react = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var AaHoverable = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(AaHoverable, _Component);

  var _super = _createSuper(AaHoverable);

  function AaHoverable(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, AaHoverable);
    _this = _super.call(this, props);
    _this.state = {
      isHovered: false,
      showHover: true
    };
    _this._handleMouseEnter = _this._handleMouseEnter.bind((0, _assertThisInitialized2["default"])(_this));
    _this._handleMouseLeave = _this._handleMouseLeave.bind((0, _assertThisInitialized2["default"])(_this));
    _this._handleGrant = _this._handleGrant.bind((0, _assertThisInitialized2["default"])(_this));
    _this._handleRelease = _this._handleRelease.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(AaHoverable, [{
    key: "_handleMouseEnter",
    value: function _handleMouseEnter(e) {
      if ((0, _AaHoverState.isHoverEnabled)() && !this.state.isHovered) {
        var onHoverIn = this.props.onHoverIn;
        if (onHoverIn) onHoverIn();
        this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isHovered: true
          });
        });
      }
    }
  }, {
    key: "_handleMouseLeave",
    value: function _handleMouseLeave(e) {
      if (this.state.isHovered) {
        var onHoverOut = this.props.onHoverOut;
        if (onHoverOut) onHoverOut();
        this.setState(function (state) {
          return _objectSpread(_objectSpread({}, state), {}, {
            isHovered: false
          });
        });
      }
    }
  }, {
    key: "_handleGrant",
    value: function _handleGrant() {
      this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          showHover: false
        });
      });
    }
  }, {
    key: "_handleRelease",
    value: function _handleRelease() {
      this.setState(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          showHover: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onHoverIn = _this$props.onHoverIn,
          onHoverOut = _this$props.onHoverOut;
      var child = typeof children === "function" ? children(this.state.showHover && this.state.isHovered) : children;
      return /*#__PURE__*/_react["default"].cloneElement(_react["default"].Children.only(child), {
        onMouseEnter: this._handleMouseEnter,
        onMouseLeave: this._handleMouseLeave,
        // prevent hover showing while responder
        onResponderGrant: this._handleGrant,
        onResponderRelease: this._handleRelease,
        // if child is Touchable
        onPressIn: this._handleGrant,
        onPressOut: this._handleRelease
      });
    }
  }]);
  return AaHoverable;
}(_react.Component);

exports["default"] = AaHoverable;
AaHoverable.displayName = "AaHoverable";